$(document).ready(function() {
    
	// System requirements display change
	$('#sysreq-select').on('change', function() {
		$('#sysreq-columns').find('.row').toggle();
	});


	//Start free trial form open/close
	$('.form-start-free-trial__openBtn').on('click', function() {
		
		$('#start-free-trial').show();
	});

	$('.form-start-free-trial__closeBtn').on('click', function() {
		
		$('#start-free-trial').hide();
	});

	// Validation box close
	$('.maximum-quantity-box__closeBtn').on('click', function() {
		$(this).parent().removeClass('show').addClass('hide');
	})

	/*
	 * ACTION BOX
	 *
	 * Products map
	 */
	var products = avastActionboxHelpers.getProductsMap( $('#managed-workplace-products option') );

	/*
	 * Installments
	 */
	var numberOfInstallments = 10;

	/*
	 * Initial state
	 */
	var initialChoice;

	/*
	 * Url parameters decoding (for initial values)
	 *
	 * Decodes url, gets 'quantity' and 'id' attributes sent from previous site/step
	 */
	var url = $.fn.creoUrlDecoder(document.location.href, false, function() {
		var id = this.getParam('id') || products[0].id;
		var quantity = parseInt(this.getParam('quantity'));

		initialChoice = {
			id: id,
			quantity: quantity
		};
	});

	/*
	 * Callback handlers
	 */
	var displayPrice = function (elements, state) {
		elements.each(function() {
			var content = $(this).data('content-text');
			//var price = avastActionboxHelpers.getPriceForVariant(state);
			var price = $().number_format(state.variant.price * state.choice.quantity, {
				numberOfDecimals: state.variant.precision,
				decimalSeparator: state.variant.decimalSeparator,
                thousandSeparator: state.variant.thousandSeparator,
                symbol: ""
            });
            var priceFormat = state.variant.priceFormat;

            if (priceFormat) {
            	price = priceFormat.replace(/\s/g, '') === '#c#p' ? (state.variant.currencySymbol + ' ' + price) : (price + ' ' + state.variant.currencySymbol);
            } else {
            	price = '';
            }

			$(this).find('span').text(content + ' ' + price);
		});
	}

	var setShopUrl = function (elements, state) {
		elements.each(function() {
			var currLink = state.variant.link || '';
			var quantity = state.choice.quantity;
			var quantityRegExp = avastActionboxHelpers.getUrlParam(currLink, 'quantity');
			var installmentsRegExp = avastActionboxHelpers.getUrlParam(currLink, 'NumberOfInstallments');
			var ptBRLocaleRegExp = currLink.match(/pt_BR/);
			var link;

			if (quantityRegExp && quantity) {
				var quantityParamParts = quantityRegExp[0];
				var quantityParam = quantityParamParts.split('.');
				
				quantityParam[1] = quantity;
				link = quantityRegExp.input.replace(quantityParamParts, quantityParam.join('.'));

				if (installmentsRegExp) {
					var installmentsParamParts = installmentsRegExp[0];
					var installmentsParam = installmentsParamParts.split('.');
					
					installmentsParam[1] = numberOfInstallments;
					link = link.replace(installmentsParamParts, installmentsParam.join('.'));
				} else if (ptBRLocaleRegExp) {
					link = link.concat('/NumberOfInstallments.' + numberOfInstallments)
				}
			} else {
				link = '#';
			}

			$(this).attr('href', link);
		});
	}

	var displayValidationBox = function (elements, state) {
		var boxesState = {
			minQuantity: 'hide',
			minQuantityMirror: ''
		};

		//boxesState = avastActionboxHelpers.getValidationBoxState(boxesState, state);
		//temp
		function getValidationBoxState(boxes, st) {
			var maxQuantity = boxes.maxQuantity;
			var minQuantity = boxes.minQuantity;
			var minQuantityMirror = boxes.minQuantityMirror;
			var enteredValue = st.choice.enteredValue;
			var limit = st.choice.limit;
			var quantity = st.choice.quantity;

			if (quantity) {
				if (enteredValue > limit[1]) {
					return { minQuantity: 'hide', minQuantityMirror: 'show', maxQuantity: 'show' }
				}

				return { minQuantity: 'hide', minQuantityMirror: 'show', maxQuantity: 'hide' }
			} 
			
			return { minQuantity: 'show', minQuantityMirror: 'hide', maxQuantity: 'hide' }
		}
		//end temp
		boxesState = getValidationBoxState(boxesState, state);

		elements.maxQuantity.attr('class', boxesState.maxQuantity);
		elements.minQuantity.attr('class', boxesState.minQuantity);
		elements.minQuantityMirror.attr('class', boxesState.minQuantityMirror);
	}

	var setTrialDataAttr = function (elements, state) {
		var choice = state.choice;
		var trialsMap = {
			'BMS-00': 'bms.100.1m',
			'BMG-00': 'bmg.100.1m',
			'BMP-00': 'bmp.100.1m'
		};

		elements.each(function() {
			$(this).data('sku', trialsMap[choice.id]);
		});
	}

	var setStickyHeaderData = function(elements, state) {
		var choice = state.choice;
		var trialsMap = {
			'BMS-00': {
				img: 'icon-business-antivirus-orange',
				name: 'Managed Business Antivirus'
			},
			'BMG-00': {
				img: 'icon-business-antivirus-pro-orange',
				name: 'Managed Business Antivirus Pro'
			},
			'BMP-00': {
				img: 'icon-business-antivirus-pro-plus-orange',
				name: 'Managed Business Antivirus Pro Plus'
			},            
			'BMP-FS': {
				img: 'icon-business-antivirus-pro-plus-orange',
				name: 'Managed Business Antivirus Pro Plus'
			}
		};

		elements.each(function() {
			$(this)
				.find('.sticky-header_img')
				.removeClass(trialsMap['BMS-00'].img + ' ' + trialsMap['BMG-00'].img + ' ' + trialsMap['BMP-00'].img)
				.addClass(trialsMap[choice.id].img)
			$(this)
				.find('.sticky-header_name')
				.text(trialsMap[choice.id].name)
		});
	}

	/*
	 * Abox Elements
	 */
	// Manager
	var actionBoxManager = new AvastActionBoxManager({
		initialState: {
			choice: initialChoice
		},
		onStateChange: function(prevState, nextState) {
			var minQuantityMirror = $('[data-validation="mirror-btn"]');
			var buyBtns = $('#abox__shoplink');
			var trialBtns = $('#abox__trialBtn, .sticky-header_wrapper a.download-trial-managed');
			var maxQuantity = $('[data-validation="maximum-quantity"]')
			var minQuantity = $('[data-validation="minimal-quantity"]');
			var stickyHeader = $('#sticky-header_wrapper');

			displayPrice(buyBtns, nextState);
			setShopUrl(buyBtns, nextState);
			setTrialDataAttr(trialBtns, nextState);
			setStickyHeaderData(stickyHeader, nextState);
			displayValidationBox({
				maxQuantity: maxQuantity,
				minQuantity: minQuantity,
				minQuantityMirror: minQuantityMirror
			}, nextState);
		}
	});

	actionBoxManager.setProducts(products);

	// Selectbox
	var selectBox = $('#managed-workplace-products');

	selectBox
		.val(initialChoice.id)
		.on('change', function() {
			var id = $(this).val();

			actionBoxManager.setVariant({
				enteredValue: devicePicker.state.value,
				id: id
			});
		});

	// Device picker
	var devicePicker = new AvastQuantityPicker($('.abox-container .select-devices'), {
		limit: [0,200],
		initialValue: initialChoice.quantity,
		onStateChange: function(state) {
			var enteredValue = state.enteredValue;
			var quantity = state.value;
			var limit = state.limit;

			actionBoxManager.setVariant({
				enteredValue: enteredValue,
				limit: limit,
				quantity: quantity
			});
		}
	});

	// Maintenance picker
	var maintenancePicker = new AvastQuantityPicker($('.abox-container .select-maintenance'), {
		limit: [1,3],
		onStateChange: function(state) {
			var enteredValue = state.enteredValue;
			var maintenance = (state.value * 12).toString();

			actionBoxManager.setVariant({
				enteredValue: enteredValue,
				maintenance: maintenance
			});
		}
	});

	/**
	 * Other
	 */
	// Comaprison table header buttons 'on click' - choose product
	$('.variant__setter').on('click', function() {
		var id = $(this).data('id');

		selectBox
			.val(id)
			.trigger('change');
	});
});